import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    /*
     * mutatable data of the store
     */
    state: {
        current: {
            quality: {},
            coverage: {},
            coverageSum: 0,
            coverageAmount: 1,
            durationValue: {},
            pricing: {
                insuranceTax: 0,
                transferFee: 0,
                serviceFee: 0,
                price: 0
            },
            startDate: '',
            endDate: '',
            contractType: '',
            timeUnit: '',
        },
        contractTypes: [],
        durationWordings: [],
        durationDropdownHeadline: '',
        bundlePrice: 0,
    },

    /*
     * getter methods for states - comparable with vue computed properties
     */
    getters: {

    },

    /*
     * methods to change store data directly
     */
    mutations: {
        setCurrent: function (state, payload) {
            state.current = payload;
        },

        setCurrentQuality: function (state, payload) {
            state.current.quality = payload;
        },

        setCurrentCoverage: function (state, payload) {
            state.current.coverage = payload;
        },

        setCurrentCoverageSum: function (state, payload) {
            state.current.coverageSum = payload;
        },

        setCurrentCoverageAmount: function (state, payload) {
            state.current.coverageAmount = payload;
        },

        setCurrentDurationValue: function (state, payload) {
            state.current.durationValue = payload;
        },

        setCurrentPricing: function (state, payload) {
            state.current.pricing = payload;
        },

        setCurrentStartDate: function (state, payload) {
            state.current.startDate = payload;
        },

        setCurrentEndDate: function (state, payload) {
            state.current.endDate = payload;
        },

        setCurrentContractType: function (state, payload) {
            state.current.contractType = payload;
        },

        setCurrentTimeUnit: function (state, payload) {
            state.current.timeUnit = payload;
        },

        setDurationWordings: function (state, payload) {
            state.durationWordings = payload;
        },

        setHideDurationSelection: function (state, payload) {
            state.hideDurationSelection = payload;
        },

        // needed data from beginning
        setContractTypes: function (state, payload) {
            state.contractTypes = payload;
        },

        setDurationDropdownHeadline: function (state, payload) {
            state.durationDropdownHeadline = payload;
        },

        // Bundle Price
        setBundlePrice: function (state, payload) {
            state.bundlePrice = payload;
        },
    },

    /*
     * Instead of mutating the state, actions commit mutations.
     * only actions can contain arbitrary asynchronous operations.
     */
    actions: {
        setInitialContractTypes: function (context, payload) {
            context.commit('setContractTypes', payload);
            context.commit('setCurrentContractType', payload.recurring);
        }
    }
})
